// Sign-off block for every supplier-reservation email ("Kind regards, / <org> /
// <consortia>"). Shared because three dialogs render the same block — the
// planner's Copy reservation details, and Operations' generic + hotel templates
// — and they sit behind different web aliases that cannot import each other.

/**
 * Consortia line shown under the organization name. Every member organization
 * on the platform belongs to the Eleggia consortium, so this is a constant
 * until the CRM redesign gives an organization its own consortia record; at
 * that point feed the stored name in as `consortia` and delete nothing else.
 */
export const DEFAULT_CONSORTIA_NAME = 'Eleggia Consortia';

export type ReservationSignatureInput = {
  organizationName: string | null | undefined;
  /** Overrides the default; falls back to `DEFAULT_CONSORTIA_NAME` when unset. */
  consortia?: string | null;
};

/**
 * The lines under "Kind regards," in booking order — organization first, then
 * the consortia it trades under. A blank entry drops its whole line rather than
 * leaving an empty row in the copied email, so an org whose title has not
 * loaded yet still produces a well-formed sign-off.
 */
export const reservationSignatureLines = ({
  organizationName,
  consortia,
}: ReservationSignatureInput): string[] =>
  [organizationName, consortia ?? DEFAULT_CONSORTIA_NAME]
    .map((line) => line?.trim() ?? '')
    .filter((line) => line.length > 0);
